import { CENTURION } from '../constants/cardTypeConstants';
import { LAST_DIGITS_NUMBER } from '../constants/travelerDataConstants';

export const getTravelerLocale = (travelerData) => travelerData?.card?.locale;

export const getCardType = (travelerData) => travelerData?.card?.type?.toLowerCase();

export const getCardArt = (travelerData) => travelerData?.card?.cardArtCdnLink;

export const getSelectedAccount = (travelerData) => {
  const loyaltyAccounts = travelerData?.loyalty?.accounts || [];

  const topCardIdCode = travelerData?.card?.cardIdCode;
  if (topCardIdCode) {
    const topCardAccount = loyaltyAccounts.find((account) => account?.cardIdCode === topCardIdCode);
    if (topCardAccount) {
      return topCardAccount;
    }
  }
  return travelerData?.loyalty?.accounts?.[0];
};

export const getTravelerPoints = (travelerData, selectedKey) => {
  if (!travelerData) return null;
  const selectedAccount = getSelectedAccount(travelerData, selectedKey);
  return selectedAccount?.points;
};

export const getIsCenturion = (travelerData) => getCardType(travelerData) === CENTURION;

export const isCenturionEligible = (
  hasCenturion,
  travelerData
) => hasCenturion && getIsCenturion(travelerData);

export const getFormattedAccountNumber = (loyaltyAccountData) => {
  const accountNumber = loyaltyAccountData?.displayAccountNumber;
  return accountNumber ? loyaltyAccountData?.displayAccountNumber.slice(-LAST_DIGITS_NUMBER) : null;
};
